<div leaflet [leafletLayers]="layers" [leafletOptions]="options" [leafletFitBounds]="fitBounds" [(leafletCenter)]="center" [(leafletZoom)]="zoom" (leafletMapReady)="onMapReady($event)" (leafletClick)="onMapClick($event)">
    <div *ngFor="let pointLayer of pointLayers" [leafletLayer]="pointLayer"></div>
    <div *ngFor="let meteoLayer of meteoLayers" [leafletLayer]="meteoLayer"></div>
    <div *ngFor="let airQualityLayer of airQualityLayers" [leafletLayer]="airQualityLayer"></div>
    <div *ngIf="timelinePointLayer" [leafletLayer]="timelinePointLayer"></div>
</div>
<dc-temporary-signal-chart *ngIf="!disableControls && !itineraryOnly"></dc-temporary-signal-chart>
<dc-map-control *ngIf="!disableControls && !itineraryOnly"></dc-map-control>
